module.exports = __webpack_public_path__ + "img/tg.653d2a15.svg";